import { createSelector } from '@ngrx/store';

import { membersState } from '../root';

export const getCurrentMember = createSelector(membersState, (members) => members?.data);
